import { lazy } from "react"
import { Navigate } from "react-router-dom"
import CloseRegister from "src/modules/sales-orders/register/pages/CloseRegister"
import OpenRegister from "src/modules/sales-orders/register/pages/OpenRegister"
import { Root } from "src/shared/components"
import { lazy as lazyImport } from "react"
import PermissionRoute from "../permission-route"
import ReturnOrderList from "src/modules/sales-orders/return-order/pages/RetrunOrderList"

const RegisterList = lazy(() => import("src/modules/sales-orders/register/pages/RegisterList"))
const RegisterSessionsList = lazyImport(() => import("src/modules/sales-orders/register/pages/RegisterSessionsList"))

const LostSalesList = lazy(() => import("src/modules/sales-orders/lost-sale/pages/LostSaleList"))

const OrdersList = lazy(() => import("src/modules/sales-orders/orders/pages/OrdersList"))
const OrderDetails = lazy(() => import("src/modules/sales-orders/orders/pages/OrderDetails"))

//  --- Discounts Routes ---
const DiscountsList = lazy(() => import("src/modules/sales-orders/discounts/pages/discountsList"))
const CreateDiscount = lazy(() => import("src/modules/sales-orders/discounts/pages/createDiscount"))
const UpdateDiscount = lazy(() => import("src/modules/sales-orders/discounts/pages/updateDiscout"))

const salesOrdersRoutes = {
  path: "sales-orders",
  element: <Root />,
  children: [
    {
      index: true,
      element: <Navigate to="register" />
    },
    {
      path: "register",
      element: <Root />,
      children: [
        {
          // there is multiple tab for list so we need to add permission route for each tab inside component
          index: true,
          element: <RegisterList />
        },
        {
          path: "sessions/:registerId",
          element: <RegisterSessionsList />
        },

        {
          path: ":registerId/open",
          element: <OpenRegister />
        },
        {
          path: ":registerId/close",
          element: <CloseRegister />
        }
      ]
    },
    {
      path: "return-order",
      element: (
        <PermissionRoute permission="sales-orders:return-order:read">
          <ReturnOrderList />
        </PermissionRoute>
      )
    },
    {
      path: "lost-sale",
      element: <Root />,
      children: [
        {
          index: true,
          element: (
            <PermissionRoute permission="sales-orders:loss-sale:read">
              <LostSalesList />
            </PermissionRoute>
          )
        }
      ]
    },
    {
      path: "order-management",
      element: <Root />,
      children: [
        {
          index: true,
          element: (
            <PermissionRoute permission="sales-orders:order-management:order-list-read">
              <OrdersList />
            </PermissionRoute>
          )
        },
        {
          path: "details/:id",
          element: (
            <PermissionRoute permission="sales-orders:order-management:order-details-read">
              <OrderDetails />
            </PermissionRoute>
          )
        }
      ]
    },
    {
      path: "discounts",
      element: <Root />,
      children: [
        {
          index: true,
          element: <DiscountsList />
        },
        {
          path: "create",
          element: <CreateDiscount />
        },
        {
          path: "update/:id",
          element: <UpdateDiscount />
        }
      ]
    }
  ]
}

export default salesOrdersRoutes
